
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 148.508 148.508"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#010002"}},[_c('path',{attrs:{"d":"M25.656 55.841H37.73l1.812 55.54H24.148zM15.394 114.4h117.721v6.338h9.055v9.056h6.338v6.339H0v-6.339h6.338v-9.056h9.056zM139.15 39.541L74.253 12.375 9.357 39.541v3.925H139.15zM21.732 46.484h105.042v6.035H21.732zM110.475 55.841h12.072l1.812 55.54h-15.394zM82.102 55.841h12.375l1.812 55.54H80.592zM54.029 55.841h12.074l1.811 55.54H52.218z"}})])])
          )
        }
      }
    